import React from "react";
import MudhalvarMarunthagam from "./MudhalvarMarunthagam";
import KooturavuMarunthagam from "./KooturavuMarunthagam";
import AmmaMarunthagam from "./AmmaMarunthagam";
import { useLanguage } from '../context/LanguageContext';

const Marunthagam = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Types of Marunthagam',
      mudhalvar: 'Mudhalvar Marunthagam',
      kooturavu: 'Kooturavu Marunthagam',
      amma: 'Amma Marunthagam'
    },
    ta: {
      title: 'மருந்தகத்தின் வகைகள்',
      mudhalvar: 'முதல்வர் மருந்தகம்',
      kooturavu: 'கூட்டுறவு மருந்தகம்',
      amma: 'அம்மா மருந்தகம்'
    }
  };

  const t = content[language];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* Main Content with Sidebar */}
      <div className="mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          
          {/* Left Navigation Panel */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-sm p-4 lg:sticky lg:top-4">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-3 border-b">
                {t.title}
              </h3>
              <nav className="space-y-2 flex flex-row lg:flex-col gap-2 lg:gap-0 overflow-x-auto lg:overflow-x-visible">
                <button
                  onClick={() => scrollToSection("mudhalvar-section")}
                  className="w-full text-left px-4 py-3 rounded-lg transition-colors text-gray-700 hover:bg-blue-100 hover:text-blue-700 whitespace-nowrap lg:whitespace-normal"
                >
                  {t.mudhalvar}
                </button>
                <button
                  onClick={() => scrollToSection("kooturavu-section")}
                  className="w-full text-left px-4 py-3 rounded-lg transition-colors text-gray-700 hover:bg-green-100 hover:text-green-700 whitespace-nowrap lg:whitespace-normal"
                >
                  {t.kooturavu}
                </button>
                <button
                  onClick={() => scrollToSection("amma-section")}
                  className="w-full text-left px-4 py-3 rounded-lg transition-colors text-gray-700 hover:bg-purple-100 hover:text-purple-700 whitespace-nowrap lg:whitespace-normal"
                >
                  {t.amma}
                </button>
              </nav>
            </div>
          </div>

          {/* Content Area - All sections rendered */}
          <div className="flex-1 space-y-8">
            
            {/* Mudhalvar Section with Heading */}
            <div id="mudhalvar-section">
              <div className="bg-blue-50 border-b border-blue-100 rounded-t-lg">
                <div className="px-4 py-6">
                  <h2 className="text-2xl font-bold text-gray-800 text-center">
                    {t.mudhalvar}
                  </h2>
                </div>
              </div>
              <MudhalvarMarunthagam />
            </div>
            
            {/* Kooturavu Section with Heading */}
            <div id="kooturavu-section">
              <div className="bg-green-50 border-b border-green-100 rounded-t-lg">
                <div className="px-4 py-6">
                  <h2 className="text-2xl font-bold text-gray-800 text-center">
                    {t.kooturavu}
                  </h2>
                </div>
              </div>
              <KooturavuMarunthagam />
            </div>
            
            {/* Amma Section with Heading */}
            <div id="amma-section">
              <div className="bg-purple-50 border-b border-purple-100 rounded-t-lg">
                <div className="px-4 py-6">
                  <h2 className="text-2xl font-bold text-gray-800 text-center">
                    {t.amma}
                  </h2>
                </div>
              </div>
              <AmmaMarunthagam />
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Marunthagam;